module.exports = __webpack_public_path__ + "img/grupo-planeta.96b795bd.jpg";